export default function setupAxios(axios, store, baseurl) {
  axios.defaults.baseURL = baseurl ?? "/rest";
  axios.defaults.headers.post["Content-Type"] =
    "application/json; charset=utf-8";

  axios.interceptors.request.use(
    (config) => {
      const {
        auth: { authToken },
      } = store.getState();

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }

      return config;
    },
    (err) => Promise.reject(err)
  );

  // Response interceptor for API calls
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async function(error) {
      console.log(error);
      const originalRequest = error.config;
      // if (error.response.status === 403 && !originalRequest._retry) {
      //   originalRequest._retry = true;
      //   const access_token = await refreshAccessToken();
      //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
      //   return axiosApiInstance(originalRequest);
      // }
      return Promise.reject(error);
    }
  );
}
